import { createContext, useContext, useEffect, useState } from 'react';

export const THEMES = {
  fuchsia: { key:'fuchsia', name:'Фуксия',  accent:'#C8005A', glow:'rgba(200,0,90,.5)',   grad:'linear-gradient(135deg,#C8005A,#8B003D)' },
  violet:  { key:'violet',  name:'Фиолет',  accent:'#6D28D9', glow:'rgba(109,40,217,.5)', grad:'linear-gradient(135deg,#6D28D9,#4C1D95)' },
  ocean:   { key:'ocean',   name:'Океан',   accent:'#0284C7', glow:'rgba(2,132,199,.5)',  grad:'linear-gradient(135deg,#0284C7,#075985)' },
  emerald: { key:'emerald', name:'Изумруд', accent:'#047857', glow:'rgba(4,120,87,.5)',   grad:'linear-gradient(135deg,#047857,#064E3B)' },
  rose:    { key:'rose',    name:'Роза',    accent:'#BE185D', glow:'rgba(190,24,93,.5)',  grad:'linear-gradient(135deg,#BE185D,#831843)' },
  amber:   { key:'amber',   name:'Золото',  accent:'#B45309', glow:'rgba(180,83,9,.5)',   grad:'linear-gradient(135deg,#B45309,#78350F)' },
};

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [isDark,   setIsDark]   = useState(() => (localStorage.getItem('ms-dark') ?? 'true') === 'true');
  const [colorKey, setColorKey] = useState(() => localStorage.getItem('ms-color') || 'fuchsia');

  const theme = THEMES[colorKey] || THEMES.fuchsia;

  useEffect(() => {
    const r = document.documentElement;
    r.classList.toggle('dark', isDark);
    r.style.setProperty('--accent',      theme.accent);
    r.style.setProperty('--accent-glow', theme.glow);
    r.style.setProperty('--accent-grad', theme.grad);
    localStorage.setItem('ms-dark',  String(isDark));
    localStorage.setItem('ms-color', colorKey);
  }, [isDark, colorKey, theme]);

  return (
    <ThemeContext.Provider value={{
      isDark, toggleDark: () => setIsDark(d=>!d),
      theme, setColor: setColorKey, themes: THEMES,
    }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
